import React from 'react';
import styled from 'styled-components';
import PageContentLoader from './PageContentLoader';
import ErrorMessage from './ErrorMessage';
const PageContentWrapper = ({ showDefaultLoader, showDefaultError, ...props }) => {
    const pageContent = () => {
        if (showDefaultLoader) {
            return React.createElement(PageContentLoader, null);
        }
        if (showDefaultError) {
            return React.createElement(ErrorMessage, { title: "Unable to load", subtitle: '' });
        }
        return props.children;
    };
    return React.createElement(Wrapper, null, pageContent());
};
const Wrapper = styled.section `
        padding: 35px 40px 40px 40px;
        `;
export default PageContentWrapper;
//# sourceMappingURL=PageContentWrapper.js.map